"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let path = /*#__PURE__*/_react.default.createElement("g", {
  id: "Groupe_452",
  "data-name": "Groupe 452",
  transform: "translate(0)"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2148",
  "data-name": "Trac\xE9 2148",
  d: "M31.8,40.147a3.179,3.179,0,0,0-2.721-2.473,84.561,84.561,0,0,0-9.424-.349,84.588,84.588,0,0,0-9.426.349,3.179,3.179,0,0,0-2.719,2.473,26.949,26.949,0,0,0-.444,5.95,26.943,26.943,0,0,0,.439,5.949,3.179,3.179,0,0,0,2.72,2.473,84.565,84.565,0,0,0,9.425.349,84.5,84.5,0,0,0,9.425-.349,3.179,3.179,0,0,0,2.72-2.473,26.964,26.964,0,0,0,.441-5.949A26.983,26.983,0,0,0,31.8,40.147ZM14.246,41.625H12.424V51.3H10.732v-9.68H8.944V40.039h5.3Zm4.6,9.68H17.32v-.916a2.437,2.437,0,0,1-1.738,1.031.933.933,0,0,1-.98-.624,4.284,4.284,0,0,1-.134-1.248V42.911h1.521v6.18a4.736,4.736,0,0,0,.014.592c.036.236.152.356.356.356.305,0,.624-.235.961-.712V42.911h1.522V51.3Zm5.778-2.519a6.705,6.705,0,0,1-.154,1.691,1.2,1.2,0,0,1-1.215.943,2.073,2.073,0,0,1-1.572-.929V51.3H20.159V40.039h1.521v3.679a2.06,2.06,0,0,1,1.572-.91,1.2,1.2,0,0,1,1.215.947,6.445,6.445,0,0,1,.154,1.687Zm5.74-1.4H27.318v1.488c0,.777.254,1.165.777,1.165a.654.654,0,0,0,.679-.61,9.569,9.569,0,0,0,.034-1.031h1.552v.222c0,.49-.019.828-.033.98a2.167,2.167,0,0,1-.355.911,2.105,2.105,0,0,1-1.84.91,2.178,2.178,0,0,1-1.841-.86,3.251,3.251,0,0,1-.488-1.974v-2.94a3.267,3.267,0,0,1,.47-1.978,2.162,2.162,0,0,1,1.822-.861,2.113,2.113,0,0,1,1.794.861,3.3,3.3,0,0,1,.471,1.978v1.738Z",
  transform: "translate(-7.067 -25.052)",
  fill: "#8adc66"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2149",
  "data-name": "Trac\xE9 2149",
  d: "M69.42,58.163q-.763,0-.763,1.164V60.1h1.521v-.777C70.177,58.551,69.923,58.163,69.42,58.163Z",
  transform: "translate(-48.405 -39.038)",
  fill: "#8adc66"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2150",
  "data-name": "Trac\xE9 2150",
  d: "M52.264,58.163a1.09,1.09,0,0,0-.759.37v5.116a1.085,1.085,0,0,0,.759.375c.439,0,.662-.375.662-1.133V59.308C52.925,58.551,52.7,58.163,52.264,58.163Z",
  transform: "translate(-36.893 -39.038)",
  fill: "#8adc66"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2151",
  "data-name": "Trac\xE9 2151",
  d: "M54.1,17.42a2.469,2.469,0,0,0,1.756-1.042V17.3H57.39V8.82H55.852V15.3c-.341.481-.664.719-.971.719-.206,0-.327-.122-.36-.36a3.563,3.563,0,0,1-.019-.6V8.82H52.97v6.708a4.285,4.285,0,0,0,.136,1.261A.944.944,0,0,0,54.1,17.42Z",
  transform: "translate(-37.876 -5.92)",
  fill: "#8adc66"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2152",
  "data-name": "Trac\xE9 2152",
  d: "M19.492,6.773v4.61h1.7V6.773L23.247,0H21.524L20.361,4.47,19.151,0H17.357c.359,1.055.733,2.116,1.093,3.172A28.042,28.042,0,0,1,19.492,6.773Z",
  transform: "translate(-13.973)",
  fill: "#8adc66"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2153",
  "data-name": "Trac\xE9 2153",
  d: "M37.584,17.21a2.1,2.1,0,0,0,1.793-.868,3.318,3.318,0,0,0,.477-1.995V11.376a3.325,3.325,0,0,0-.477-2,2.279,2.279,0,0,0-3.583,0,3.3,3.3,0,0,0-.481,2v2.971a3.288,3.288,0,0,0,.481,1.995A2.1,2.1,0,0,0,37.584,17.21Zm-.734-6.142c0-.785.238-1.176.734-1.176s.733.391.733,1.176v3.568c0,.785-.237,1.177-.733,1.177s-.734-.393-.734-1.177Z",
  transform: "translate(-26.025 -5.71)",
  fill: "#8adc66"
}));
let viewBox = '0 0 25.169 29.816';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'YoutubeIcon', viewBox);
